module.exports = "<div id=\"content\">\n\t<ng-include src=\"'controls.html'\"></ng-include>\n\n\t<div id=\"chart\" class=\"chart\" data-chart-type=\"bar\"></div>\n\n\t<ng-include ng-if=\"!reportCtrl.AppService.compare\" src=\"'overview-base-table.html'\"></ng-include>\n\t<ng-include ng-if=\"reportCtrl.AppService.compare\" src=\"'overview-compare-table.html'\"></ng-include>\n</div>\n\n<div class=\"modal-background\" ng-show=\"appCtrl.modal\" ng-click=\"appCtrl.closeModal();\">\n\t<div class=\"modal\" ng-show=\"appCtrl.modal\">\n\t\t<div id=\"overview-chart\" class=\"chart\" data-chart-type=\"line\"></div>\n\t</div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/views/html/overview-report.html
 ** module id = 32
 ** module chunks = 0
 **/